<div class="d-flex rounded border align-items-center p-2" *ngIf="message">
    <div class="alrt_fsize15" [ngClass]="getClass()"></div>
    <div>{{message}}</div>
</div>